import { CATEGORY_COLORS, POI_CATEGORIES, type POICategoryId, type POIType } from "../../types";

// questa funziona permette di stampare in console i bounds della mappa
export function logCurrentBounds(map: any) {
    if (!map) {
        console.log('Mappa non inizializzata');
        return;
    }

    const bounds = map.getBounds();
    const center = map.getCenter();
    const zoom = map.getZoom();

    const boundsData = {
        zoom: zoom,
        center: {
            lt: center.lat,
            lg: center.lng
        },
        bounds: {
            sw: {
                lt: bounds.getSouth(),
                lg: bounds.getWest()
            },
            ne: {
                lt: bounds.getNorth(),
                lg: bounds.getEast()
            }
        }
    };

    console.log('=== MAP BOUNDS ===');
    console.log(JSON.stringify(boundsData, null, 2));

    return boundsData;
}


// Helper per icone POI – emoji (compatibilità / UI testuali)
export const getPOIIcon = (type: POIType): string => {

    const icons = POI_CATEGORIES.reduce((acc, category) => {
        category.types.forEach(t => {
            acc[t.id] = t.icon;
        });
        return acc;
    }, {} as Record<POIType, string>);

    return icons[type] || '📍';
}

// Helper per simboli POI – Google Material Symbols
// Ritorna il "nome" del simbolo (es. "info", "restaurant").
export const getPOISymbol = (type: POIType): string => {

    const symbols = POI_CATEGORIES.reduce((acc, category) => {
        category.types.forEach(t => {
            acc[t.id] = t.symbol;
        });
        return acc;
    }, {} as Record<POIType, string>);

    return symbols[type] || 'location_on';
}

export type POIColorToken = {
    cssVar: string;
    fallback: string;
};

export const getPOICategoryId = (type: POIType): POICategoryId | null => {
    const cat = POI_CATEGORIES.find(c => c.types.some(t => t.id === type));
    return (cat?.id as POICategoryId | undefined) || null;
};

export const getPOIColorToken = (type: POIType): POIColorToken => {
    const categoryId = getPOICategoryId(type);
    if (categoryId && CATEGORY_COLORS[categoryId]) {
        return CATEGORY_COLORS[categoryId];
    }
    return CATEGORY_COLORS.info;
};

export const getPOIColorCssValue = (type: POIType): string => {
    const t = getPOIColorToken(type);
    return `var(${t.cssVar}, ${t.fallback})`;
};

// Calcola distanza in metri (formula Haversine semplificata)
export const calculateDistance = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
    const R = 6371e3; // Raggio della Terra in metri
    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;
    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return Math.round(R * c);
};

export const formatTimeAgo = (timestamp: number): string => {
    const date = new Date(timestamp);
    const mins = Math.floor((Date.now() - date.getTime()) / 60000);
    if (mins < 1) return 'ora';
    if (mins === 1) return '1 minuto fa';
    if (mins < 60) return `${mins} minuti fa`;
    const hours = Math.floor(mins / 60);
    return hours === 1 ? '1 ora fa' : `${hours} ore fa`;
};
